/**
 * Compact processor catalog for the activation page "I already have a
 * processor" option. Mirrors the logos used on the create-processor grid
 * (PROCESSOR_METADATA) but trimmed to name + logo, shown small as social
 * proof that the merchant can plug whatever they already use.
 *
 * Order roughly by recognizability so the most reassuring brands lead.
 */
export interface ProcessorLogo {
	name: string
	logo: string
}

export const ONBOARDING_PROCESSOR_LOGOS: ProcessorLogo[] = [
	{ name: 'Stripe', logo: '/integrations/stripe-icon.svg' },
	{ name: 'Braintree', logo: '/integrations/braintree-icon.png' },
	{ name: 'Checkout.com', logo: '/integrations/checkout-icon.svg' },
	{ name: 'Airwallex', logo: '/integrations/airwallex-icon.svg' },
	{ name: 'Worldpay', logo: '/integrations/worldpay-icon.png' },
	{ name: 'Fiserv', logo: '/integrations/fiserv-icon.png' },
	{ name: 'Global Payments', logo: '/integrations/globalpay-icon.png' },
	{ name: 'NMI', logo: '/integrations/nmi-icon.png' },
	{ name: 'Authorize.Net', logo: '/integrations/authorizenet-icon.png' },
	{ name: 'Mollie', logo: '/integrations/mollie-icon.png' },
	{ name: 'Mastercard', logo: '/integrations/mastercard.svg' },
	{ name: 'Paysafe', logo: '/integrations/paysafe-icon.png' },
	{ name: 'BlueSnap', logo: '/integrations/bluesnap-icon.png' },
	{ name: 'PAYONE', logo: '/integrations/payone-icon.png' },
	{ name: 'PayU', logo: '/integrations/payu-icon.png' },
	{ name: 'Razorpay', logo: '/integrations/razorpay-icon.png' },
	{ name: 'Paystack', logo: '/integrations/paystack-icon.png' },
	{ name: 'Finix', logo: '/integrations/finix-icon.jpg' },
	{ name: 'Tap Payments', logo: '/integrations/tap-icon.svg' },
	{ name: 'Network Ngenius', logo: '/integrations/network-ngenius-icon.png' },
	{ name: 'CCAvenue', logo: '/integrations/ccavenue-logo.png' },
	{ name: 'Payland', logo: '/integrations/payland-icon.png' },
	{ name: 'Ovri', logo: '/integrations/ovri-icon.png' },
	{ name: 'KessPay', logo: '/integrations/kesspay-icon.png' },
	{ name: 'Trust Flow', logo: '/integrations/trustflow.png' },
]
